// Central URL builders for SEO-friendly, keyword-rich paths.
// Legacy paths (/villes/:x, /fasciatherapie/:x, /coach-sportif/:x) are kept
// as 301 redirects to preserve existing SEO and inbound links.

// The coach-sportif specialty slug "sport-senior" is rewritten to "senior" in the URL
// for a cleaner, more SEO-friendly path.
const coachSlugToUrlSlug = (slug) => (slug === "sport-senior" ? "senior" : slug);

export const fasciaUrl = (slug) => `/fasciatherapie-${slug}-toulouse`;
export const coachUrl = (slug) => `/coach-sportif-${coachSlugToUrlSlug(slug)}-toulouse`;
export const cityUrl = (slug) => `/fasciatherapie-coach-sportif-${slug}`;

// Reverse mapping: URL slug back to specialty data slug
export const urlSlugToCoachSlug = (urlSlug) => (urlSlug === "senior" ? "sport-senior" : urlSlug);
